import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#lebensversicherung

	{
        "antragstellerIds": [ String ],
        "praemieMonatlich": BigDecimal
    }


*/

export const schemaEuropaceUpdateLebensversicherung = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    praemieMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateLebensversicherung = z.infer<typeof schemaEuropaceUpdateLebensversicherung>;
